import { __module as s } from "./index871.mjs";
import { g as e } from "./index767.mjs";
import { d as t } from "./index764.mjs";
var a = e, i = t, o = "__core-js_shared__", r = s.exports = a[o] || i(o, {});
(r.versions || (r.versions = [])).push({
  version: "3.41.0",
  mode: "global",
  copyright: "© 2014-2025 Denis Pushkarev (zloirock.ru)",
  license: "https://github.com/zloirock/core-js/blob/v3.41.0/LICENSE",
  source: "https://github.com/zloirock/core-js"
});
var c = s.exports;
export {
  c as s
};
